import React from 'react';

import { FontSize, FormWrapper, Slider, Switch } from '../../../WidgetConfiguratorComponents/FormGroups';
import { WarningBoxConfigBlockState } from '../types';

const DEFAULT_MIN_MONITOR_ROW = 1;
const DEFAULT_MAX_MONITOR_ROW = 4;
const DEFAULT_SHOW_SUMMARIES_TEXT = 'Show summaries:';
const DEFAULT_MONITOR_LABEL = 'Monitor per row:';
const DEFAULT_BLOCK_BACKGROUND_COLOUR_TEXT = 'Use threshold color as background';

interface GeneralSettingsConfigurator {
    viewblockState: WarningBoxConfigBlockState;
    setViewblockState: React.Dispatch<React.SetStateAction<WarningBoxConfigBlockState>>;
}

export const GeneralSettingsConfigurator = ({ viewblockState, setViewblockState }: GeneralSettingsConfigurator) => {
    const summariseWarningsSwitchFormProps = {
        checkedChildren: 'Show',
        unCheckedChildren: 'Hide',
    };

    const blockBackgroundColorSwitchProps = {
        checkedChildren: 'Yes',
        unCheckedChildren: 'No',
    };

    const marks = {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
    };

    return (
        <FormWrapper>
            <FontSize
                fontSize={viewblockState.settings.fontSize}
                onChange={(fontSize: number) => setViewblockState({ ...viewblockState, settings: { ...viewblockState.settings, fontSize } })}
            />
            <Slider
                label={DEFAULT_MONITOR_LABEL}
                onChange={(rowSize: number) => setViewblockState({ ...viewblockState, settings: { ...viewblockState.settings, rowSize } })}
                value={viewblockState.settings.rowSize}
                min={DEFAULT_MIN_MONITOR_ROW}
                max={DEFAULT_MAX_MONITOR_ROW}
                marks={marks}
            />
            <Switch
                label={DEFAULT_SHOW_SUMMARIES_TEXT}
                value={viewblockState.settings.summariseWarnings}
                onChange={(summariseWarnings: boolean) => setViewblockState({ ...viewblockState, settings: { ...viewblockState.settings, summariseWarnings } })}
                {...summariseWarningsSwitchFormProps}
            />
            <Switch
                label={DEFAULT_BLOCK_BACKGROUND_COLOUR_TEXT}
                value={viewblockState.settings.blockBackgroundColor}
                onChange={(blockBackgroundColor: boolean) =>
                    setViewblockState({ ...viewblockState, settings: { ...viewblockState.settings, blockBackgroundColor } })
                }
                {...blockBackgroundColorSwitchProps}
            />
        </FormWrapper>
    );
};
